<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card dashboardTable">

      <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left" *ngIf="isAtalbhujal">
          <button (click)="onAtalbhujalFarmer()" pButton pRipple label="{{'ADD_FARMER' | translate}}" icon="pi pi-plus"
            class="p-button-success mr-2"></button>
        </ng-template>
        <ng-template pTemplate="right">
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}" icon="pi pi-upload"
            class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
        </ng-template>
      </p-toolbar>

      <p-table #dashboardTable [value]="farmerAppDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[ 
          'appID', 
          'farmerName', 
          'village', 
          'status', 
          'remarks', 
          'block', 
          'district', 
          'registerationDate_filter', 
          'FinYear' 
        ]" [rowHover]="true" dataKey="id" 
        currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
        [showCurrentPageReport]="true" responsiveLayout="scroll" [loading]="loading">
        
        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{'MANAGE_FARMERS_APPLICATION' | translate}}</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search"></i>
              <input class="p-input-icon-left" pInputText type="text"
                (input)="dashboardTable.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{'SEARCH' | translate}}" />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="appID">
              {{'APP_NO' | translate}}
              <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
              <p-sortIcon field="appID"></p-sortIcon>
            </th>
            <th pSortableColumn="farmerName">
              {{'FARMER_NAME' | translate}}
              <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
              <p-sortIcon field="farmerName"></p-sortIcon>
            </th>
            <th pSortableColumn="registerationDate">
              {{'DATE_OF_REG' | translate}}
              <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
              <p-sortIcon field="registerationDate"> </p-sortIcon>
            </th>
            <th pSortableColumn="village">
              {{'VILLAGE' | translate}}
              <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
              <p-sortIcon field="village"></p-sortIcon>
            </th>
            <th pSortableColumn="block">
              {{'BLOCK' | translate}}
              <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
              <p-sortIcon field="block"></p-sortIcon>
            </th>
            <th pSortableColumn="district">
              {{'DISTRICT' | translate}}
              <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
              <p-sortIcon field="district"></p-sortIcon>
            </th>
            <th pSortableColumn="status">
              {{'STATUS' | translate}}
              <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="remarks">
              {{'REMARKS' | translate}}
              <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
              <p-sortIcon field="remarks"></p-sortIcon>
            </th>
            <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR' | translate}}
              <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
              <p-sortIcon field="FinYear"></p-sortIcon>
            </th>
            <th>{{'ACTION' | translate}}</th>
            <th>{{'TRACK_APPLICATION_STATUS' | translate}}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-farmerAppDetail>
          <tr>
            <td>{{ farmerAppDetail.appID }}</td>
            <td>{{ farmerAppDetail.farmerName }}</td>
            <td>{{ farmerAppDetail.registerationDate | date }}</td>
            <td>{{ farmerAppDetail.village }}</td>
            <td>{{ farmerAppDetail.block }}</td>
            <td>{{ farmerAppDetail.district }}</td>
            <td>{{ farmerAppDetail.status }}</td>
            <td>{{ farmerAppDetail.remarks }}</td>
            <td>{{ farmerAppDetail.FinYear}}</td>
            <td>
              <!-- <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
            class="p-button-info ml-3"></button> -->
              <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                class="p-button-rounded p-button-accent mx-1 my-1 btnSize"
                (click)="printForm(farmerAppDetail.appID, farmerAppDetail.Status_Ar)"></button>
              <button pButton pRipple pTooltip="edit application" icon="pi pi-pencil"
                *ngIf="farmerAppDetail.IsEditable == '1'" class="p-button-rounded p-button-success mx-1 my-1 btnSize"
                (click)="editForm(farmerAppDetail.appID)"></button>
              <button pButton pRipple pTooltip="delete application" icon="pi pi-trash"
                *ngIf="farmerAppDetail.IsEditable == '1'" class="p-button-rounded p-button-danger mx-1 my-1 btnSize"
                (click)="deleteForm(farmerAppDetail.appID)"></button>
            </td>
            <td>
              <button *ngIf="!display" pButton pRipple pTooltip="View application status"  label="{{'VIEW_APPLICATION_STATUS' | translate}}"
        class="p-button-rounded p-button-accent mx-1 my-1 btnSize" icon="pi pi-chart-bar" (click)="showDialog(farmerAppDetail)"></button>
       
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
          </div>
        </ng-template>
      </p-table>

    </div>

    <p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

  </div>
</div>

<p-dialog 
  [(visible)]="display"
  [modal]="true"
  [closable]="true"
  header="Application Status {{selectedAppId}}"
  [style]="{width: '90vw', maxWidth: '95vw'}"       
  [contentStyle]="{height: 'auto', overflowX: 'auto', overflowY: 'auto'}" 
  [baseZIndex]="-101"
  [dismissableMask]="true">   <div *ngIf="viewApplicationWorkFlowDiag">
    <app-application-work-flow-diag [applicationId]="selectedAppId"></app-application-work-flow-diag>
  </div>

  <ng-template pTemplate="footer">
    <div style="display: flex; flex-wrap: wrap; gap: 1rem; align-items: center; width: 100%;padding-top: 0.5rem;">
      
      <strong style="margin-right: 1rem;">Legend:</strong>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #2E7D32; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Approved</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #F9A825; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Pending</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #C62828; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Rejected</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #EF6C00; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Data Required</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #8E24AA; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Reply Pending</span>
      </span>
      
      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #90A4AE;; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Unknown</span>
      </span>

    </div>
  </ng-template>
  </p-dialog>
